import { service } from "@server/client";
import type {
  RemoveFromCartMutation,
  RemoveFromCartMutationVariables,
} from "@server/gql/graphql";
import { removeFromCartMutation } from "@server/queries/cart";

export const removeFromCart = async (
  variables: RemoveFromCartMutationVariables,
) => {
  try {
    const response = await service<
      RemoveFromCartMutation,
      RemoveFromCartMutationVariables
    >({
      query: removeFromCartMutation,
      variables,
    });

    return response.cart;
  } catch (error: Error | unknown) {
    console.error("Error in removeFromCart", error);
    throw error;
  }
};
